import UsersPage from './UsersPage';

export type TViewMode = 'row' | 'grid';

export default UsersPage;
